/* eslint-disable max-len */
class StyleFinder extends HTMLElement {
  constructor() {
    super();
    this.json = JSON.parse(document.getElementById('stylefinderJSON').textContent);
    this.styleFinder = document.getElementsByTagName('style-finder')[0]; // eslint-disable-line
    this.overlay = document.getElementById('modal-overlay');
    this.content = document.getElementById('style-finder-content');
    this.progress = document.getElementById('progress-completion');
    this.back = document.getElementById('style-finder-back');
    this.result = document.getElementById('result');
    this.openModalButtons = document.querySelectorAll('[data-open-style-finder-modal]');
    this.closeModalButtons = document.querySelectorAll('[data-close-style-finder-modal]');
    this.openModalButtons.forEach((btn) => btn.addEventListener('click', this.open.bind(this)));
    this.closeModalButtons.forEach((btn) => btn.addEventListener('click', this.close.bind(this)));
    this.back.addEventListener('click', this.generatePrevious.bind(this));
    this.progressPercentage = 0;

    if (window.location.href.includes('style-finder')) {
      this.open();
    }
  }

  open() {
    this.overlay.classList.remove('hidden');
    this.styleFinder.classList.remove('hidden');
    this.generateContent(this.json.style_finder, this.progressPercentage);
  }

  close() {
    this.overlay.classList.add('hidden');
    this.styleFinder.classList.add('hidden');
    this.content.innerHTML = '';
  }

  generateContent(data) {
    this.clearActiveButtons();
    this.clearResult();
    const div = document.createElement('div');
    if (data.hide_back === true) {
      this.back.classList.add('hidden');
      div.setAttribute('data-step', 1);
    } else {
      this.back.classList.remove('hidden');
    }
    this.progressPercentage += 20;
    if (this.progressPercentage > 80) this.progressPercentage = 80;
    this.updateProgressBar();
    if (data.heading !== undefined) {
      const h3 = document.createElement('h3');
      h3.classList.add('welcome');
      h3.innerHTML = data.heading;
      div.appendChild(h3);
    }
    if (data.question !== undefined) {
      if (data.heading !== undefined) {
        // display question as less emphasized than heading
        const p = document.createElement('p');
        p.innerHTML = data.question;
        div.appendChild(p);
      } else {
        // make question as heading & display with more emphasis
        const h3 = document.createElement('h3');
        h3.innerHTML = data.question;
        div.appendChild(h3);
      }
    }
    const buttonDiv = document.createElement('div');
    buttonDiv.classList.add('inline-grid');
    data.choices.forEach((choice) => {
      const btn = document.createElement('button');
      btn.innerHTML = choice.answer;
      if (choice.subsequent !== undefined) {
        btn.addEventListener('click', this.generateContent.bind(this, choice.subsequent));
      } else if (choice.result !== undefined) {
        btn.addEventListener('click', this.generateLink.bind(this, choice.result, btn));
      }
      buttonDiv.appendChild(btn);
    });
    div.appendChild(buttonDiv);
    this.content.appendChild(div);
  }

  generateLink(data, btn) {
    this.clearActiveButtons();
    this.clearResult();
    btn.classList.add('active');
    const anchor = document.createElement('a');
    anchor.innerHTML = 'Show Results';
    anchor.setAttribute('href', data);
    this.result.appendChild(anchor);
    // result is being shown, update progress to maximum value
    this.progressPercentage = 100;
    this.updateProgressBar();
  }

  updateProgressBar() {
    // set minimum & maximum values for progress percentage
    if (this.progressPercentage > 100) this.progressPercentage = 100;
    else if (this.progressPercentage < 20) this.progressPercentage = 20;
    this.progress.style.width = `${this.progressPercentage}%`;
  }

  generatePrevious() {
    this.clearResult();
    this.progressPercentage -= 20;
    if (this.content.lastChild !== null) this.content.removeChild(this.content.lastChild);
    if (this.content.lastChild.getAttribute('data-step') !== null) {
      // first step is being shown, reset progress bar from start
      this.back.classList.add('hidden');
      this.progressPercentage = 20;
    }
    this.updateProgressBar();
  }

  clearResult() {
    if (this.result.lastChild !== null) this.result.removeChild(this.result.lastChild);
  }

  clearActiveButtons() {
    const activeButtons = this.content.querySelectorAll('.active');
    activeButtons.forEach((btn) => {
      btn.classList.remove('active');
    });
  }
}

customElements.get('style-finder') || customElements.define('style-finder', StyleFinder); // eslint-disable-line

export default StyleFinder;
